import { Moon, Sun } from "lucide-react";
import { useTheme } from "../../context/ThemeContext";

/* Two-state segmented control (Dark · Light). Ported from the Claude Design
   handoff (design-system-001); styled against the EchoSense token layer so it
   tracks whichever theme is active. Dark is the brand default. */

const SIZES = {
  sm: { h: 28, pad: "0 9px", font: 11.5, icon: 13, gap: 5 },
  md: { h: 36, pad: "0 13px", font: 13, icon: 15, gap: 7 },
};

export function ThemeToggle({ size = "sm", style = {}, ...rest }) {
  const { theme, setTheme } = useTheme();
  const d = SIZES[size] || SIZES.sm;

  const options = [
    { id: "dark", label: "Dark", Icon: Moon },
    { id: "light", label: "Light", Icon: Sun },
  ];

  return (
    <div
      role="group"
      aria-label="Color theme"
      style={{
        display: "inline-flex",
        padding: 3,
        gap: 2,
        borderRadius: "var(--radius-pill)",
        background: "var(--bg-hover)",
        border: "1px solid var(--border-subtle)",
        ...style,
      }}
      {...rest}
    >
      {options.map((o) => {
        const active = theme === o.id;
        const Icon = o.Icon;
        return (
          <button
            key={o.id}
            type="button"
            aria-pressed={active}
            data-testid={`theme-toggle-${o.id}`}
            onClick={() => setTheme(o.id)}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: d.gap,
              height: d.h,
              padding: d.pad,
              border: 0,
              cursor: "pointer",
              borderRadius: "var(--radius-pill)",
              fontFamily: "var(--font-display)",
              fontWeight: 600,
              fontSize: d.font,
              letterSpacing: "0.01em",
              transition: "background var(--duration-fast) var(--ease-out), color var(--duration-fast) var(--ease-out)",
              background: active ? "var(--es-accent)" : "transparent",
              color: active ? "var(--text-on-gold)" : "var(--text-secondary)",
              boxShadow: active ? "var(--shadow-xs)" : "none",
            }}
          >
            <Icon size={d.icon} aria-hidden="true" />
            {o.label}
          </button>
        );
      })}
    </div>
  );
}

export default ThemeToggle;
